import React, {useState, useEffect,} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";
import FinderSelect from 'react-finderselect';
import { Web } from '@material-ui/icons';


export default ({InfIdUse, InfIdConta, IdUse, IdConta, setAddList, setUsuariosContServ, UsuariosContServ,  Dados, Avisando, Fechar, Id, setAlert, setAlertTipo, MsgDesativar}) => {

const [Titulo, setTitulo] = useState("Criar Conta Aluno");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [Img2, setImg2] = useState("../assets/avatarimg.png");
const [Imgs2, setImgs2] = useState("");
const [Nome, setNome] = useState("");
const [Telefone, setTelefone] = useState("");
const [Mensalidade, setMensalidade] = useState("0000");
const [DiaMes, setDiaMes] = useState("00");
const [AtualAno, setAtualAno] = useState("0000"); 
const [QuantApp, setQuantApp] = useState("0000");
const [ValorApp, setValorApp] = useState("0000");
const [End, setEnd] = useState("");
const [Num, setNum] = useState("");
const [Bairro, setBairro] = useState("");
const [Cidade, setCidade] = useState("");
const [Estado, setEstado] = useState("");
const [NomeEmp, setNomeEmp] = useState("");
const [NomeApp, setNomeApp] = useState("");
const [AppLimit, setAppLimit] = useState(false);
const [TokenMP, setTokenMP] = useState("");
const [KeyMP, setKeyMP] = useState("");
const [WebHookMP, setWebHookMP] = useState("");
const [ReceberMP, setReceberMP] = useState(true);
const [ListRepres, setListRepres] = useState([]);
const [ListRespTel, setListRespTel] = useState([]);
const [IdRepr, setIdRepr] = useState("");
const [Versao, setVersao] = useState("1.0.0");
const [MedidasAtiv, setMedidasAtiv] = useState(true);
const [GratisAtiv, setGratisAtiv] = useState(false);
const [Porcen, setPorcen] = useState("");
const [Alunos, setAlunos] = useState();




useEffect(() => {
  if(IdConta){
  
    PegandoValor() 
   }       
    }, [IdConta])

    useEffect(() => {
      if(Porcen){
      PreencherFormulario()   
      }
          
       }, [Porcen])

 useEffect(() => {
       ListRepresentante();     
      }, [])

 const handleToggle1 = () => {
    setGratisAtiv(!GratisAtiv);
  };
   
     const handleToggle4 = () => {
    setMedidasAtiv(!MedidasAtiv);
  };
const PreencherFormulario = () => {
  setMedidasAtiv(Porcen.MedidasAtiv)
  setVersao(Porcen.Versao)
  }

    const PegandoValor  = ()=>{
  
        // if (navigator.onLine) {
        //   setMsgErro("")
           
        //  Api.TAClientesDadosPagar(IdConta, setPorcen, setAlunos);
   
        // } else {
        //   setAlert("Sem Internet");
        //   setAlertTipo("danger");
        // }
      
    }
 const ListRepresentante = async ()=>{
    await Api.TAListRepresentantesSelect(Dados, setListRepres, setListRespTel)
   }

  const criando = ()=>{

    var TAMensalidade = parseInt(Mensalidade)
    var TADiaMes = parseInt(DiaMes)
    


    

    if(GratisAtiv){
    if(Nome !=="" && Nome !==" " && Nome !=="  " && Nome !=="   " && Nome !=="    " && Nome !=="     " && Nome !=="      "
    && Nome !=="       " && Nome !=="        " && Nome !=="         " && Nome !=="          " 
    && Nome !=="           " ){
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
        Api.TACriarAlunos(GratisAtiv, IdConta, InfIdUse,  IdUse, MedidasAtiv, Versao,  Nome,  Imgs2,  Telefone,   Mensalidade, DiaMes,  Estado, Cidade, Bairro, Num, End,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList);
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setMsgErro("Preencha o Nome Completo do Aluno.")
    }

    } else {
    if(TADiaMes > 0 && TADiaMes < 27 ){
    if(TAMensalidade >= 0){
    if(Nome !=="" && Nome !==" " && Nome !=="  " && Nome !=="   " && Nome !=="    " && Nome !=="     " && Nome !=="      "
    && Nome !=="       " && Nome !=="        " && Nome !=="         " && Nome !=="          " 
    && Nome !=="           " ){
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
        Api.TACriarAlunos(GratisAtiv, IdConta, InfIdUse,  IdUse, MedidasAtiv, Versao,  Nome,  Imgs2,  Telefone,   Mensalidade, DiaMes,  Estado, Cidade, Bairro, Num, End,  setMsgErro, setLoading, setAlertTipo, setAlert, setAddList);
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setMsgErro("Preencha o Nome Completo do Cliente.")
    }
    
    } else {
        setMsgErro("Valor Mensalidade só pode Número.")
    }
    } else {
        setMsgErro("Dia do Mês não é valido.")
    }  
   } 
  }


  const ColocarImg2 = (e)=>{
    const reader = new FileReader()
    reader.onload = () => {
      if(reader.readyState === 2) {
        setImg2(reader.result);
      }
    }
   reader.readAsDataURL(e.target.files[0]);
    setImgs2(e.target.files[0]);
  }
  const ExcImg2 = ()=>{
   
    setImgs2("");
    setImg2("../assets/avatarimg.png");
  }

  
     
      
   

        return (
            <>
<div className="content-wrapper">
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
            
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                    <i className="far fa-address-card" /> Aluno 
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <div className="row invoice-info">
                <div className="col-sm-4 invoice-col">
                  <address>
                    {Loading  ?
                    <>
                      <Spinner 
                      size={64}
                      color={"#5d0bf7"}
                      sizeUnit={'px'} 
                      /><br />
                      </>
                      :
                      <>
                       {Dados &&
                                  <>
                        {Dados.Alunos.Btn.botão_Criar &&
                        <>
                          <div className="col-12">
                          <Butao 
                          style={"btn .btn-sm btn-info"}
                          titulo={"Salvar"}
                          onClick={()=>criando()}
                          />  
                         </div><br />
                                  </>
                                  }
                                  </>
                                  }
                   
                    
                     {MsgErro !== "" &&
                    <>
                    <div class="alert alert-danger alert-dismissible">
                  
                  <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                  {MsgErro}
                </div>
                   
                    </>
                    }
                    </>
                    }
                    
                   
                    
                    <strong>Nome do Aluno</strong><br />
                    <div className="input_cadatro">
                             
                      
                      <input
                              type="text"
                              value={Nome}
                              onChange={t=>setNome(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Nome do Aluno"
                             
                            />
                            </div> 
                    <br />
                 
                   <strong>Telefone do Aluno</strong><br />
                    <div className="input_cadatro">
                              
                              <Campo 
                                type={"tel"}
                                placeholder={"Digite Whatsapp"}
                                icon={"fas fa-phone"}
                                value={Telefone}
                                onChange={e=>setTelefone(e.target.value)}
                                mask={"(99)99999-9999"}
                                />

                            </div> 
                    <br />
                    <div style={{ textAlign: "center",  }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={handleToggle1}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: GratisAtiv ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: GratisAtiv ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {GratisAtiv ? "App Grátis Ativo" : "App Grátis Desativado"}
                          </span>
                        </label>
                      </div>
                      {GratisAtiv === false &&
                        <>
                        
                        
                        
                    <strong>Dia do Mês</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={DiaMes}
                              onChange={t=>setDiaMes(t.target.value)}
                              maxLength={2}
                              className="border p-2 rounded"
                              placeholder="00"
                              size={4}
                            />

                            </div> 
                    <br />
                     <strong>Valor Mensalidade</strong><br />
                     
                    <div className="input_cadatro">
                          <string>R$ </string>    
                              <input
                              type="text"
                              value={Mensalidade}
                              onChange={t=>setMensalidade(t.target.value)}
                              maxLength={4}
                              className="border p-2 rounded"
                              placeholder="0000"
                              size={4}
                            />
                          <string>,00</string>
                   
                            </div> 
                            <br /> 
                    </>
                      }  
                     <div style={{ textAlign: "center",  }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={handleToggle4}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: MedidasAtiv ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: MedidasAtiv ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {MedidasAtiv ? "Medidas Ativo" : "Medidas Desativado"}
                          </span>
                        </label>
                      </div>  
                    
                     <strong>Versão do APP</strong><br />
                     <string>{Versao}</string><br />
                   
                   
                    
                   
                     
                  
                 
                     
                  </address>
                    </div>
                      <div className="col-sm-4 invoice-col">
                    <address>
                      <strong>Endereço</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={End}
                              onChange={t=>setEnd(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Endereço"
                            />

                            </div> 
                    <br />   
                     <strong>Numero</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Num}
                              onChange={t=>setNum(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Numero"
                            />

                            </div> 
                    <br />   
                      <strong>Bairro</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Bairro}
                              onChange={t=>setBairro(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Bairro"
                            />

                            </div> 
                    <br />   
                  <strong>Cidade</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Cidade}
                              onChange={t=>setCidade(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Cidade"
                            />

                            </div> 
                    <br /> 
                    <strong>Estado</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Estado}
                              onChange={t=>setEstado(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite a Estado"
                            />

                            </div> 
                    <br />   
                  
                     
                    
                    </address>
                   </div>
                    <div className="col-sm-4 invoice-col">
                    <address>
                     
                    <strong>Foto do Aluno:</strong><br />
                    <div className="FotosArqui" >
                    <div className="FotoQuaAnun" >
                      {Img2 === "../assets/avatarimg.png" ?
                         <img src={Img2} alt="imagem" className="FotoQua2" />
                      :
                      <img src={Img2} alt="imagem" className="FotoQua1" />
                      }
                   
                    </div>
                  
                 
                  

                    {Imgs2 === "" ?
                  <div className="row no-print">
                   <div className="col-12">
                      <input 
                      type="file" 
                      id="fileInput"
                      accept="image/*" 
                      style={{ display: "none" }} 
                      onChange={(e) => ColocarImg2(e)} 
                    />

                    <label htmlFor="fileInput" className="btn-custom">
                      Escolher imagem
                    </label>
                    </div>
                   </div>
                  
                   
                    :
                    <div className="row no-print">
                   <div className="col-12">
                  <Butao 
                   style={"btn .btn-sm btn-danger"}
                   titulo={"Excluir"}
                   onClick={()=>ExcImg2()}
                   />  
                   </div>
                   </div>

                    } 

                   </div>
  
                    </address>
                   </div>
              </div>
              <div className="row no-print">
              </div>
              
            
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}